import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
export default function UserView() {
  let { id } = useParams();
  const [formval, setFormval] = useState({});

  useEffect(() => {
    (async () => {
      try {
        let response = await axios(`${baseUrl}/user/${id}`, {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });

        if (response?.data?.status === true) {
          const data = response.data.data;

          setFormval({
            name: data.name || "",
            email: data.email || "",
            mobile: data.mobile?.toString() || "",
            gender: data.gender || "",
            subDivision: data.subDivision || "",
            state: data.state || "",
            pin: data.pin || "",
            study_interested: data.study_interested || "N/A",
            status: data.status ? "Active" : "Inactive",
          });

        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    })();
  }, []);


  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-users me-2" />
                View Users
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    View Users
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards edit-usr">
              <form action="">
                <div className="row">
                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.name}
                    />
                  </div>

                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.email}
                    />
                  </div>

                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Mobile Number</label>

                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={formval.mobile}
                    />
                  </div>

                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Gender</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.gender}
                    />
                  </div>
                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Study Interested</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.study_interested}
                    />
                  </div>




                  <div className="col-lg-3 mb-4">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.state}
                    />
                  </div>

                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Subdivision</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.subDivision}
                    />
                  </div>
                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Status</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.status}
                    />
                  </div>
                  <div className="col-lg-3 mb-4">
                    <label className="form-label">PIN</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      defaultValue={formval?.pin}
                    />
                  </div>


                  <div className="col-lg-12 text-center">
                    <Link
                      to="/students"
                      type="Submit"
                      className="thm-btn"
                      disabled
                    >
                      <i className="fa fa-chevron-left" /> &nbsp; back
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
